<top-banner variant="small"></top-banner>


<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
            title="Sites with Scheduling"
            icon="fas fa-list">
          </card-section-header>
          <div class="row">
            <div class="col-md-12">
              <p-table [value]="sites" selectionMode="single" [responsive]="true" [autoLayout]="true" (onRowSelect)="onRowSelect($event)">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Site Name</th>
                    <th>Description</th>
                    <th>Owner</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-site>
                  <tr [pSelectableRow]="site">
                    <td>
                      <span class="p-column-title">Site Name</span>
                      {{site.site.name}}
                      <div class="small-data">
                        <span>S{{site.site.id}}</span>
                      </div>
                    </td>

                    <td><span class="p-column-title">Description</span>{{site.site.description}}</td>
                    <td><span class="p-column-title">Owner</span>{{site.site.siteOwner.firstName}} {{site.site.siteOwner.lastName}}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="6">
                      No sites found
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator [alwaysShow]="false" [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

